export const COUNTRIES = [
  { value: 'UAE', label: 'United Arab Emirates' },
  { value: 'Oman', label: 'Oman' },
  { value: 'Saudi Arabia', label: 'Saudi Arabia' },
  { value: 'Bahrain', label: 'Bahrain' },
  { value: 'Kuwait', label: 'Kuwait' },
  { value: 'Qatar', label: 'Qatar' },
  { value: 'Egypt', label: 'Egypt' },
  { value: 'Jordan', label: 'Jordan' },
  { value: 'Lebanon', label: 'Lebanon' },
  { value: 'India', label: 'India' },
];
